module.exports = __webpack_public_path__ + "static/media/bg_login.0cc95b83.jpg";